module.exports = __webpack_public_path__ + "img/popup_hand.1770a848.jpg";